export enum ELegalStatus {
  ACTIVE = '3b87a7b9-0901-4c1c-892e-b4585d732b38',
  INACTIVE = '235185e2-20d0-4210-a9b6-cdf5062a4549',
}
